import script from "./TextareaElement.vue?vue&type=script&lang=js"
export * from "./TextareaElement.vue?vue&type=script&lang=js"

import "./TextareaElement.vue?vue&type=style&index=0&id=285da712&lang=scss"

const __exports__ = script;

export default __exports__